import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { finalize } from 'rxjs/operators'
import { LoadingSpinnerService } from '../loading-spinner/loading-spinner.service'

export const SPINNER_ENABLED = new HttpContextToken<boolean>(() => false)
export const SPINNER_MESSAGE = new HttpContextToken<string>(() => '')
export const SPINNER_TITLE = new HttpContextToken<string | undefined>(() => undefined)

export const loadingSpinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerService = inject(LoadingSpinnerService)
  if (req.context.get(SPINNER_ENABLED)) {
    spinnerService.show(req.context.get(SPINNER_MESSAGE), req.context.get(SPINNER_TITLE))
  }
  return next(req).pipe(
    finalize(() => {
      if (req.context.get(SPINNER_ENABLED)) {
        spinnerService.hide()
      }
    })
  )
}
